import { CompanyPage } from "../models/company-page-store.model";
import * as CompanyPageActions from "../actions/company-page.actions";

const initialState: CompanyPage = {
  meta: {},
};

export function companyPageReducer(
  state: CompanyPage = initialState,
  action: CompanyPageActions.Actions,
) {
  let newMeta = state.meta;
  switch (action.type) {
    case CompanyPageActions.SET_COMPANY_PAGE_META:
      newMeta = { ...newMeta };
      newMeta[action.payload.ticker] = action.payload.value;
      return {
        ...state,
        meta: newMeta,
      };
    default:
      return state;
  }
}
